import { render, staticRenderFns } from "./QuestionnaireForm.vue?vue&type=template&id=875e7906"
import script from "./QuestionnaireForm.vue?vue&type=script&lang=js"
export * from "./QuestionnaireForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireForm.vue?vue&type=style&index=0&id=875e7906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports